'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TraceTypeScatterpolarIcon = function TraceTypeScatterpolarIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 46 46' }, props),
        _react2.default.createElement('path', { fill: 'none', d: 'M0 0h46v46H0z' }),
        _react2.default.createElement('path', { fill: '#25fdfc', stroke: '#1d9bfb', d: 'M38.985 32.246l-16 9.221L7 32.221l.015-18.467 16-9.221L39 13.779l-.015 18.467z', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2' }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#1d9bfb', d: 'M33.99 29.357l-11 6.339L12 29.339l.01-12.696 11-6.339L34 16.661l-.01 12.696z', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2' }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#1d9bfb', d: 'M28.994 26.467l-6 3.458L17 26.458l.006-6.925 6-3.458L29 19.542l-.006 6.925zM39 32L7 14m0 18l32-18M23 5v36.185', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2' })
    );
};

exports.default = TraceTypeScatterpolarIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/plotly-icons/lib/components/TraceTypeScatterpolarIcon.js
// module id = 728
// module chunks = 0